<template>
  <div class="columns is-mobile">
    <div class="column">
      <div class="columns">
        <b-message
          title="Employer Information"
          type="is-info"
          aria-close-label="Close message"
          v-if="empAlert"
        >
          Continuing as a Guest does not relieve you of the responsibility to file a First Notice of Loss as required by your state.
          <br />
          <br />If you log into your
          <a
            href="https://secure.republicindemnity.com/wps/portal/policyholder/login/"
          >Policyholder account</a> to report a claim, a First Notice of Loss will be automatically generated.
        </b-message>
      </div>
      <div class="columns">
        <div class="column">
          <b-field
            label="Who are you?"
            expanded
            :type="{'is-danger': errors.has('basics.title')}"
            :message="errors.first('basics.title')"
          >
            <b-select
              placeholder="Please select"
              v-model="fnoldata.preparer.title"
              expanded
              v-validate="'required'"
              data-vv-as="title"
              data-vv-scope="basics"
              name="title"
            >
              <option value="InjuredWorker">Injured Worker</option>
              <option value="Attorney">Attorney</option>
              <option value="Employer">Employer</option>
              <option value="MedicalProvider">Medical Provider</option>
              <option value="Other">Other</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field
            label="When did injury occur?"
            expanded
            :type="{'is-danger': errors.has('basics.doi')}"
            :message="errors.first('basics.doi')"
          >
            <b-datepicker
              placeholder="Select a date..."
              icon="calendar-today"
              v-model="fnoldata.injury.dateOfInjury"
              name="doi"
              v-validate="'required'"
              :max-date="maxDate"
              data-vv-as="Date of Injury"
              data-vv-scope="basics"
            >
              <button class="button is-warning" @click="fnoldata.injury.dateOfInjury = new Date()">
                <b-icon icon="calendar-today"></b-icon>
                <span>Today</span>
              </button>
              <button class="button is-warning" @click="fnoldata.injury.dateOfInjury = ''">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Time of injury/illness">
            <b-timepicker
              placeholder="Click to select..."
              name="timeofinjury"
              v-model="injTime"
              rounded
              icon="clock"
              hour-format="12"
            ></b-timepicker>
          </b-field>
        </div>
      </div>
      <b-field
        label="First Name"
        :type="{'is-danger': errors.has('basics.firstname')}"
        :message="errors.first('basics.firstname')"
      >
        <b-input
          v-model="fnoldata.preparer.fname"
          name="firstname"
          v-validate="'required|alpha_spaces'"
          data-vv-as="First Name"
          data-vv-scope="basics"
        />
      </b-field>
      <b-field
        label="Last Name"
        :type="{'is-danger': errors.has('basics.lastname')}"
        :message="errors.first('basics.lastname')"
      >
        <b-input
          v-model="fnoldata.preparer.lname"
          name="lastname"
          v-validate="'required|alpha_spaces'"
          data-vv-as="Last Name"
          data-vv-scope="basics"
        />
      </b-field>
      <b-field
        label="How do you want us to notify you?"
        :type="{'is-danger': errors.has('basics.notify')}"
        :message="errors.first('basics.notify')"
      >
        <b-select
          ref="notify"
          placeholder="Please select"
          v-model="fnoldata.preparer.notifyBy"
          name="notify"
          v-validate="'required'"
          data-vv-as="Notify"
          data-vv-scope="basics"
        >
          <option value="Email">Email</option>
          <option value="Phone">Phone</option>
        </b-select>
      </b-field>
      <b-field
        label="Email"
        :type="{'is-danger': errors.has('basics.email')}"
        :message="errors.first('basics.email')"
      >
        <b-input
          icon="email"
          type="email"
          v-model="fnoldata.preparer.email"
          name="email"
          data-vv-as="email"
          data-vv-scope="basics"
          maxlength="30"
        />
      </b-field>
      <b-field
        label="Phone"
        :type="{'is-danger': errors.has('basics.phone')}"
        :message="errors.first('basics.phone')"
      >
        <b-input
          v-model="workPhone"
          name="phone"
          v-validate="'required:Phone|min:16'"
          data-vv-as="phone"
          data-vv-scope="basics"
          maxlength="16"
        />
      </b-field>
    </div>
  </div>
</template>
<script>
export default {
  props: ["fnoldata"],
  inject: ["parentValidator"],
  created() {
    this.$validator = this.parentValidator;
  },
  data() {
    const today = new Date();
    return {
      workPhone: "",
      maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      injTime: new Date(new Date().setHours(0, 1, 0, 0)),
      empAlert: false
    };
  },
  filters: {
    workPhoneDisplay: {
      read: function(val) {
        alert(val);
        return val
          .replace(/[^0-9]/g, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
      },
      write: function(val, oldVal) {
        alert("write" + " " + val);
        return "" + val.replace(/[^\d.]/g, "");
      }
    }
  },
  computed: {
    injuryDate: function() {
      return this.fnoldata.injury.dateOfInjury;
    }
  },
  methods: {},
  watch: {
    injuryDate: function(val) {
      if (val) {
        this.fnoldata.injury.dateOfInjury = val;
        this.fnoldata.injury.timeOfInjury = val;
        this.fnoldata.injury.timeOfInjury.setMinutes(this.injTime.getMinutes());
        this.fnoldata.injury.timeOfInjury.setHours(this.injTime.getHours());
      }
    },
    injTime: function(val) {
      this.fnoldata.injury.timeOfInjury.setMinutes(this.injTime.getMinutes());
      this.fnoldata.injury.timeOfInjury.setHours(this.injTime.getHours());
    },
    workPhone: function(input) {
      //alert(input);
      input = input.replace(/\D/g, "");

      // Trim the remaining input to ten characters, to preserve phone number format
      input = input.substring(0, 10);

      // Based upon the length of the string, we add formatting as necessary
      var size = input.length;
      if (size == 0) {
        //input = input; do nothing.
      } else if (size < 4) {
        input = "(" + input;
      } else if (size < 7) {
        input = "(" + input.substring(0, 3) + ") " + input.substring(3, 6);
      } else {
        input =
          "(" +
          input.substring(0, 3) +
          ") " +
          input.substring(3, 6) +
          " - " +
          input.substring(6, 10);
      }
      this.workPhone = input;
      this.fnoldata.preparer.phone.work = input.replace(/[^\d.]/g, "");
      //   // fnoldata.preparer.phone.work
    },
    "fnoldata.preparer.title": function(input) {
      this.empAlert = false;
      if (input == "Employer") {
        this.fnoldata.employer.empInformed = "Yes";
        this.empAlert = true;
      }
    }
  }
};
</script>


